import React, { ReactNode } from "react";
import { Box, Text } from "@chakra-ui/react";

interface HrmsStatCardProps {
  label: string;
  value: ReactNode;
  /** Colour of the big value. Defaults to the HRMS teal. */
  accent?: string;
  helpText?: ReactNode;
}

/**
 * KPI tile used on the HRMS dashboards. Previously duplicated inline in
 * ManagerDashboard / AdminDashboard.
 */
export const HrmsStatCard = ({
  label,
  value,
  accent = "#308888",
  helpText,
}: HrmsStatCardProps) => (
  <Box bg="white" p={4} borderRadius="12px" border="1px solid #e2e8f0">
    <Text
      fontSize="12px"
      fontWeight="700"
      color="#495057"
      textTransform="uppercase"
      mb={1}
    >
      {label}
    </Text>
    <Text fontSize="28px" fontWeight="800" color={accent} mb={0} lineHeight="1.2">
      {value}
    </Text>
    {helpText && (
      <Text fontSize="12px" color="gray.500" mb={0} mt={1}>
        {helpText}
      </Text>
    )}
  </Box>
);
